<template>
  <div v-if="cptdOfferCardComp" class="OfferCardTemplateMethodContainer">
    <component
      :is="cptdOfferCardComp"
      v-if="cptdOfferCardComp"
      :offer="offer"
      :custom-partner-tags="customPartnerTags"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
import { OfferStatus } from '@/data/common'
import OfferCard from '@/components/commomComponents/cards/OfferCard.vue'
import AutoColdOfferCardContainer from '@/containers/loans/auto/offer/AutoColdOfferCardContainer.vue'
import AutoProposedOfferCardContainer from '@/containers/loans/auto/offer/AutoProposedOfferCardContainer.vue'
import AutoValidatingOfferCardContainer from '@/containers/loans/auto/offer/AutoValidatingOfferCardContainer.vue'
import NoCollateralProposedOfferCardContainer from '@/containers/loans/no-collateral/offer/NoCollateralProposedOfferCardContainer.vue'
import NoCollateralUnauthOfferCardContainer from '@/containers/loans/no-collateral/offer/NoCollateralUnauthOfferCardContainer.vue'
import HomeEquityColdOfferCardContainer from '@/containers/loans/home-equity/offer/HomeEquityColdOfferCardContainer.vue'
import HomeEquityValidatingOfferCardContainer from '@/containers/loans/home-equity/offer/HomeEquityValidatingOfferCardContainer.vue'
import HomeEquityProposedOfferCardContainer from '@/containers/loans/home-equity/offer/HomeEquityProposedOfferCardContainer.vue'
export default {
  name: 'OfferCardTemplateMethodContainer',
  components: {
    OfferCard,
    AutoColdOfferCardContainer,
    AutoProposedOfferCardContainer,
    AutoValidatingOfferCardContainer,
    NoCollateralProposedOfferCardContainer,
    NoCollateralUnauthOfferCardContainer,
    HomeEquityColdOfferCardContainer,
    HomeEquityValidatingOfferCardContainer,
    HomeEquityProposedOfferCardContainer,
  },
  props: {
    offer: { type: Object, required: true },
    customPartnerTags: { type: Object, default: undefined },
  },
  computed: {
    cptdOfferCardComp() {
      const { status, product_type } = this.offer

      if (OfferStatus.VALIDATING === status) {
        switch (product_type) {
          case 'auto':
            return 'AutoValidatingOfferCardContainer'
          case 'home-equity':
            return 'HomeEquityValidatingOfferCardContainer'
        }
      }
      switch (product_type) {
        case 'auto':
          return 'AutoProposedOfferCardContainer'
        case 'auto-cold-offer':
          return 'AutoColdOfferCardContainer'
        case 'no-collateral-unauth':
          return 'NoCollateralUnauthOfferCardContainer'
        case 'no-collateral':
          return 'NoCollateralProposedOfferCardContainer'
        case 'home-equity-cold-offer':
          return 'HomeEquityColdOfferCardContainer'
        case 'home-equity':
          return 'HomeEquityProposedOfferCardContainer'
        default:
          return 'OfferCard'
      }
    },
  },
}
</script>
<style lang="scss">
.OfferCardTemplateMethodContainer {
  & > .partner-card {
    margin-top: 0;
    margin-bottom: 0;
    max-width: 100%;

    &:first-child {
      margin: 0;
    }
  }
}
</style>
